module.exports = __webpack_public_path__ + "img/cosy_natural_ba_list.a0adfd8d.jpg";